import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, isSameData,
  isSameList, SerializationContext, SerializedData } from '../dto/dto.js';
import { ScheduleTimeSpan } from './schedule-time-span.js';

export class ScheduleTemplate extends DataModel {
  static readonly TYPE_ID: string = 'aa7c1283f8264868a10fa056ce5cf03a';

  constructor(
    public readonly uniqueId: string,
    public readonly name: string,
    public readonly times: ScheduleTimeSpan[],
  ) {
    super();
  }

  get $typeId(): string {
    return ScheduleTemplate.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ScheduleTemplate {
    return new ScheduleTemplate(
        MapUtils.get<string>(map, 'uniqueId'),
        MapUtils.get<string>(map, 'name'),
        MapUtils.getList<ScheduleTimeSpan>(map, 'times', (data: unknown) => context.fromData(data as SerializedData)),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'name': this.name,
      'times': this.times.map((value: ScheduleTimeSpan) => context.toData(value)),
    };
  }

  clone(): this {
    return new ScheduleTemplate(
        this.uniqueId,
        this.name,
        this.times.map((value: ScheduleTimeSpan) => {
          return value.clone();
        }),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        other.name === this.name &&
        isSameList(other.times, this.times, (a: ScheduleTimeSpan, b: ScheduleTimeSpan) => {
          return isSameData(a, b);
        });
  }
}

export class ScheduleTemplateBuilder extends DataModelBuilder<ScheduleTemplate> {
  build(context: SerializationContext, map: SerializedData): ScheduleTemplate {
    return ScheduleTemplate.fromMap(context, map);
  }
}
